import React from 'react'

const WebsiteIdContext = React.createContext()
WebsiteIdContext.displayName = 'WebsiteIdContext'

export default WebsiteIdContext
